import '.n{position:relative;}.ssr-plugin'
import '.bj{overflow:hidden;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.fj{padding:8px;}.ssr-plugin'
import '.k1{border-radius:8px;}.ssr-plugin'
import '.bw{margin-left:auto;}.ssr-plugin'
import '.gk{margin-right:auto;}.ssr-plugin'
import '.b3{display:block;}.ssr-plugin'
import '.k{margin:0 auto;}.ssr-plugin'
import '.ib{max-width:100%;}.ssr-plugin'
import '.dg{height:auto;}.ssr-plugin'
import '.fl{padding:4px;}.ssr-plugin'
import '.a3{gap:4px;}.ssr-plugin'
import '.an{border-radius:12px;}.ssr-plugin'
import '.p{position:absolute;}.ssr-plugin'
import '.k2{top:20px;}.ssr-plugin'
import '.k3{right:20px;}.ssr-plugin'
import { useLexicalNodeSelection } from '@lexical/react/useLexicalNodeSelection.js'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext.js'
import { mergeRegister } from '@lexical/utils'
import {
  $getNodeByKey,
  $getSelection,
  $isDecoratorNode,
  $isNodeSelection,
  CLICK_COMMAND,
  COMMAND_PRIORITY_LOW,
  KEY_BACKSPACE_COMMAND,
  KEY_DELETE_COMMAND,
} from 'lexical'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { colors } from '../../tokens/colors.js'
import { styled } from 'inlines'
// import { ImageUploadModal } from './ImageUploadModal'
import { BLUR_COMMAND, COMMAND_PRIORITY_EDITOR } from 'lexical'
import { $isImageNode } from './nodes/ImageNode.js'
import { AddImageModal } from './Toolbar/AddImageModal.js'
import { Text } from '../Text/index.js'
import { Button } from '../Button/index.js'
import { Separator } from '../Separator/index.js'

export const ImageComponent = ({
  src,
  caption,
  nodeKey,
}: {
  src?: string
  caption?: string
  nodeKey: string
}) => {
  const [editor] = useLexicalComposerContext()

  const [hover, setHover] = useState(false)

  const [isSelected, setSelected, clearSelection] =
    useLexicalNodeSelection(nodeKey)
  const ref = useRef<HTMLDivElement | null>(null)

  const onDelete = useCallback(
    (event: KeyboardEvent) => {
      if (isSelected && $isNodeSelection($getSelection())) {
        event.preventDefault()
        const node = $getNodeByKey(nodeKey)
        if ($isDecoratorNode(node)) {
          node.remove()
        }
      }

      return false
    },
    [isSelected, nodeKey],
  )

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand<MouseEvent>(
        CLICK_COMMAND,
        (event) => {
          if (
            event.target === ref.current ||
            ref.current?.contains(event.target as Node)
          ) {
            clearSelection()
            setSelected(true)
            return true
          }

          return false
        },
        COMMAND_PRIORITY_LOW,
      ),
      editor.registerCommand(
        KEY_DELETE_COMMAND,
        onDelete,
        COMMAND_PRIORITY_LOW,
      ),
      editor.registerCommand(
        KEY_BACKSPACE_COMMAND,
        onDelete,
        COMMAND_PRIORITY_LOW,
      ),
      editor.registerCommand(
        BLUR_COMMAND,
        () => {
          clearSelection()
          return true
        },
        COMMAND_PRIORITY_EDITOR,
      ),
    )
  }, [clearSelection, editor, isSelected, nodeKey, onDelete, setSelected])

  return (
    <div className="n bj a i c d h fj k1 bw gk"
      ref={ref}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        border: `1px solid ${colors.neutral20Adjusted}`,
        backgroundColor: colors['neutral10Background'],
      }}
    >
      <img className="b3 k ib dg"
        src={src}
        alt=""
      />
      {caption && <Text style={{ marginTop: 6 }}>{caption}</Text>}

      {hover && (
        <div className="a fl a3 an p k2 k3"
          style={{
            border: `1px solid ${colors.neutral20Adjusted}`,
            background: `linear-gradient(${colors.neutral10Background}),
                         linear-gradient(${colors.neutralInverted100})`,}}
        >
          <AddImageModal
            onSave={(val) => {
              editor.update(() => {
                const node = $getNodeByKey(nodeKey)
                if ($isImageNode(node)) {
                  const writable = node.getWritable()
                  if (val.file) {
                    writable.__src = val.file.src
                  }
                  writable.__caption = val.caption
                }
              })
            }}
          >
            <Button leadIcon="edit" variant="ghost" size="small">
              Edit
            </Button>
          </AddImageModal>
          <Separator
            orientation="vertical"
            variant="line"
            style={{ height: 16 }}
          />
          <Button
            color="red"
            leadIcon="delete"
            variant="ghost"
            size="small"
            onClick={() => {
              editor.update(() => {
                const node = $getNodeByKey(nodeKey)
                node.remove()
              })
            }}
          >
            Remove
          </Button>
        </div>
      )}
    </div>
  )
}
